<template>
  <v-row class="fill-height">
    <v-col class="fill-height pb-0">
      <v-card rounded class="fill-height actions-info">
        <v-card-text>
          <player-actions2></player-actions2>
          <club-info></club-info>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex';
import PlayerActions2 from "./PlayerActions2";
import ClubInfo from "./ClubInfo";
export default {
  name: "ActionsInfo",
  components: {ClubInfo, PlayerActions2},
  computed: {
    ...mapState([
    ]),
  },
}
</script>

<style scoped>
  .actions-info {
    overflow-y: auto;
  }
</style>
